export default [
    /**
     * 302 Temporary
    */

    // Other
    {
        path: '^/for-individuals/crediting/consumer-loan/potreb-goals',
        redirectTo: '/for-individuals/crediting/consumer-loan/credit-for-all',
        code: 302,
    },
    {
        path: '^/for-individuals/refinancing',
        redirectTo: '/for-individuals',
        code: 302,
    },
    {
        path: '^/for-individuals/refinancing/mortgage-refinancing',
        redirectTo: '/for-individuals',
        code: 302,
    },
    {
        path: '^/ru/dbo$',
        redirectTo: '/dbo',
        code: 302,
    },
    {
        path: '^/for-individuals/cards/debet-cards/stiсker$', // в урле русская буква
        redirectTo: '/for-individuals/cards/debet-cards/sticker',
        code: 302,
    },

    /**
     * 301 Permanently
    */
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-deti',
        redirectTo: '/for-individuals/mortgage/mortgage-children',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-s-gospodderzhkoy',
        redirectTo: '/for-individuals/mortgage/new-building',
        code: 301,
    },
    {
        path: '^/for-individuals/cards/credit-cards',
        redirectTo: '/for-individuals/crediting/credit-cards',
        code: 301,
    },
    {
        path: '^/processing_agreement',
        redirectTo: '/media/about/processing__agreement.pdf',
        code: 301,
    },
];
